<div class="row">
  <div [ngClass]="[time ? 'col-10' : 'col-12']">
    <div
      class="time-remainnig-bar"
      [ngClass]="[time ? '' : 'time-remainnig-bar-upload']"
    >
      <div #timeRemainnigProgress class="time-remainnig-progress"></div>
    </div>
  </div>
  <div class="col-2" *ngIf="time">
    <div class="time-remainnig-text">
      {{ countTimer | async | SecondsToMinutesPipe }}
    </div>
  </div>
</div>
